export default __webpack_public_path__ + "static/media/avatar.d62bd270.png";